import { ArrowLeft, ArrowRight } from "lucide-react";
import { logo, resell } from "@/lib/bf";

const Step = ({ n, label, value, tone }) => (
  <div className={`bf-yours-step ${tone || ""}`} data-testid={`bf-yours-step-${n}`}>
    <em>{n}</em><small>{label}</small><strong>{value}</strong>
  </div>
);

export default function BFYours({ cfg, go }) {
  const camps = cfg.campaigns.filter((c) => c.category === "oferta" && c.resell_discount > 0 && resell(100, c)?.win > 0);
  const ex = camps.find((c) => c.brand === "medavita") || camps[0];
  const r = ex && resell(100, ex);
  const even = r ? Math.ceil((10 * r.pay) / r.sell) : 0;
  const name = (id) => cfg.brands.find((b) => b.id === id)?.name || id;
  return (
    <section className="bf-zone bf-yours" data-testid="bf-yours">
      <button type="button" className="bf-back" onClick={() => go("")} data-testid="bf-back"><ArrowLeft size={15} /> Înapoi</button>
      <h2 className="bf-zone-title">Black Friday-ul tău</h2>
      <p className="bf-zone-sub">Cumperi cu reducere, faci și tu reducere clientelor tale și tot câștigi. Simplu, fără calcule.</p>
      {r && (
        <div className="bf-yours-example" data-testid="bf-yours-example">
          <p className="bf-yours-lead">Exemplu {name(ex.brand)}: orice produs din ofertă</p>
          <div className="bf-yours-steps">
            <Step n="1" label="Tu cumperi cu" value={`-${ex.discount}%`} />
            <Step n="2" label="În magazinul online costă" value={ex.resell_markup ? `+${ex.resell_markup}% față de lista ta` : "cât lista ta de salon"} tone="is-muted" />
            <Step n="3" label="Tu îl vinzi clientei cu" value={`-${ex.resell_discount}% față de online`} />
            <Step n="4" label="Câștigi din fiecare vânzare" value={`${r.pct}%`} tone="is-win" />
          </div>
          <p className="bf-yours-even" data-testid="bf-yours-even">Iei 10 bucăți, vinzi <b>{even}</b> și ți-ai scos banii. Celelalte <b>{10 - even}</b> sunt câștigul tău.</p>
          <p className="bf-yours-note">Clientele tale plătesc mai puțin decât online, așa că vin la tine. Tu faci rulaj și poți comanda din nou.</p>
        </div>
      )}
      <h3 className="bf-yours-h3">Cât câștigi din fiecare vânzare, pe brand</h3>
      <div className="bf-yours-brands">
        {camps.map((c) => {
          const x = resell(100, c);
          return (
            <button key={c.id} type="button" className="bf-yours-brand" onClick={() => go(`b/${c.brand}`)} data-testid={`bf-yours-brand-${c.brand}`}>
              <img src={logo(c.brand)} alt={name(c.brand)} />
              <span>Cumperi cu <b>-{c.discount}%</b></span>
              <span>Vinzi cu <b>-{c.resell_discount}%</b> <small>față de online{c.resell_markup ? "" : " (preț de listă)"}</small></span>
              <span className="is-win">Câștigi <b>{x.pct}%</b> <small>din vânzare</small></span>
            </button>
          );
        })}
      </div>
      <p className="bf-yours-note">Procentele sunt aceleași la toate produsele din oferta brandului. În coș vezi cât câștigi din toată comanda.</p>
      <button type="button" className="bf-yours-btn" onClick={() => go("branduri")} data-testid="bf-yours-shop">Alege produsele <ArrowRight size={16} /></button>
    </section>
  );
}
